import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Button } from '@telus-uds/components-web';
import Edit from '@telus-uds/palette-allium/build/web/icons/Edit';
import Overlay from './overlay';

const EditButton = ({ id, name, fetchData }) => {
  const [inEditMode, setInEditMode] = useState(false);

  return (
    <>
      <Button
        icon={Edit}
        onPress={() => {
          setInEditMode(true);
        }}
        accessibilityLabel="Edit"
        variant={{ text: true }}
      />
      {inEditMode && (
        <Overlay
          setInEditMode={setInEditMode}
          id={id}
          name={name}
          fetchData={fetchData}
        />
      )}
    </>
  );
};

EditButton.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  fetchData: PropTypes.func.isRequired
};

export default EditButton;
